import ticket from '@/assets/ticket.svg';
export default {
    title: 'Билеты',
    icon: ticket,
    list: [
        {
            id: 50, // id товара в invoicer
            title: 'Билет участника',
            description: '',
            count: 120,
            cost: 15000,
            options: [
                // 'опция',
                // 'опция',
                // 'опция',
                // 'опция',
                // 'опция',
            ],
            promocode: true,
        },
        {
            id: 51, // id товара в invoicer
            title: 'Билет участника + Нетворкинг',
            description: '',
            count: 150,
            cost: 25000,
            options: [
                // 'Нетворкинг',
                // 'опция',
                // 'опция',
                // 'опция',
                // 'опция',
                // 'опция',
                // 'опция',
            ],
            promocode: true,
        },
    ]
}